"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const react_1 = require("react");
const jsx_runtime_1 = require("react/jsx-runtime");
/*
 * Input.tsx
 * Author: fwunderlich
 * Date: 01.03.2022
 *
 * Copyright: DMT GmbH & Co. KG
 */
const react_2 = __importStar(require("react"));
const inputtext_1 = require("primereact/inputtext");
const inputtextarea_1 = require("primereact/inputtextarea");
const dropdown_1 = require("primereact/dropdown");
const multiselect_1 = require("primereact/multiselect");
const checkbox_1 = require("primereact/checkbox");
const react_i18next_1 = require("react-i18next");
const react_hook_form_1 = require("react-hook-form");
const utils_1 = require("primereact/utils");
const inputnumber_1 = require("primereact/inputnumber");
const selectbutton_1 = require("primereact/selectbutton");
const inputswitch_1 = require("primereact/inputswitch");
const treeselect_1 = require("primereact/treeselect");
const calendar_1 = require("primereact/calendar");
const tooltip_1 = require("primereact/tooltip");
const button_1 = require("primereact/button");
const slider_1 = require("primereact/slider");
const Global_1 = require("../functions/Global");
const CustomToast_1 = require("./CustomToast");
const Input = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)('input');
    let component = (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    const ref = (0, react_2.useRef)(null);
    const focusRef = (0, react_2.useRef)(null);
    const [eventAdded, setEventAdded] = react_2.default.useState(false);
    let timeoutFocusOnTable = null;
    const onKeyDown = (e) => {
        if (e.keyCode === 13) {
            e.preventDefault();
            return false;
        }
    };
    const onFocus = (e) => {
        if (ref.current) {
            // console.log('ref', ref.current);
            let input = ref.current;
            if (input.getElement) {
                input = input.getElement();
            }
            e.preventDefault();
            input.classList.add('is-focused-tablet');
            timeoutFocusOnTable = setTimeout(() => {
                window.scrollTo(0, 0);
            }, 350);
        }
    };
    const onBlur = (e) => {
        if (ref.current) {
            // console.log('ref', ref.current);
            let input = ref.current;
            if (input.getElement) {
                input = input.getElement();
            }
            e.preventDefault();
            input.classList.remove('is-focused-tablet');
            input.parentElement.parentElement.scrollIntoView();
        }
    };
    (0, react_2.useEffect)(() => {
        if (ref.current) {
            // console.log('ref', ref.current);
            let input = ref.current;
            if (input.getElement) {
                input = input.getElement();
            }
            if (!eventAdded) {
                // console.log('add event', input);
                setEventAdded(true);
                switch (input.type) {
                    case 'textarea':
                        // do nothing
                        break;
                    default:
                        input.addEventListener('keydown', onKeyDown);
                        break;
                }
                if ((0, Global_1.isTablet)()) {
                    if (input) {
                        input.addEventListener('focus', onFocus);
                        input.addEventListener('blur', onBlur);
                    }
                }
            }
            else {
                // console.log('activeElement', document.activeElement, input);
                if ((0, Global_1.isTablet)()) {
                    if (document.activeElement === input) {
                        input.classList.add('is-focused-tablet');
                    }
                }
            }
        }
        return () => {
            if (ref.current) {
                // console.log('ref', ref.current);
                let input = ref.current;
                if (input.getElement) {
                    input = input.getElement();
                }
                input.removeEventListener('keydown', onKeyDown);
                input.removeEventListener('focus', onFocus);
                input.removeEventListener('blur', onBlur);
            }
            clearTimeout(timeoutFocusOnTable);
        };
    }, [ref.current, props.value]);
    // useEffect(() => {
    //     console.log('label: ', props.label);
    //     console.log('input: ', props.value);
    // }, [props.value]);
    let displayStr = 'comma';
    if (props.type === 'treeSelect') {
        if (props.selectionMode === 'multiple' || props.selectionMode === 'checkbox') {
            displayStr = 'chip';
        }
    }
    const groupedItemTemplate = (option) => {
        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "flex align-items-center" }, { children: [(0, jsx_runtime_1.jsx)("i", { className: "pi pi-list" }), (0, jsx_runtime_1.jsx)("span", { children: "\u00A0" }), (0, jsx_runtime_1.jsx)("label", { children: (0, jsx_runtime_1.jsx)("b", { children: option.label }) })] })));
    };
    const className = 'custom-inputfield mt-3' + (props.inputClassName ? ' ' + props.inputClassName : '');
    // Letztes Element hinter den Punkten oder props.name selbst
    const tooltipName = props.name.split('.').pop() || props.name;
    const inputLabel = props.label ?
        ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "flex" }, { children: [(0, jsx_runtime_1.jsx)("h5", Object.assign({ className: "input-label" }, { children: props.label + (props.validationControl && (!props.validationRules || props.validationRules.required) ? '*' : '') })), props.tooltip &&
                    (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(tooltip_1.Tooltip, { target: '.' + tooltipName, content: props.tooltip }), (0, jsx_runtime_1.jsx)("i", { className: 'pi pi-info-circle pl-2 my-auto ' + tooltipName })] }), props.labelIcon && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(tooltip_1.Tooltip, { target: `#icon-tooltip-${tooltipName}`, content: props.labelIconTooltip || 'Icon Info' }), (0, jsx_runtime_1.jsx)("span", Object.assign({ id: `icon-tooltip-${tooltipName}`, className: "ml-2 my-1 cursor-pointer" }, { children: props.labelIcon }))] }))] }))) : null;
    const getInputNumber = (field, fieldState) => {
        return ((0, jsx_runtime_1.jsx)(inputnumber_1.InputNumber, { inputRef: ref, id: field === null || field === void 0 ? void 0 : field.name, className: 'w-full', inputClassName: className + ' w-full ' + (0, utils_1.classNames)({ 'p-invalid': fieldState === null || fieldState === void 0 ? void 0 : fieldState.invalid }), inputId: "locale-german", locale: "de-DE", mode: "decimal", useGrouping: typeof props.useGrouping === 'boolean' ? props.useGrouping : true, minFractionDigits: 0, maxFractionDigits: props.maxFractionDigits ? props.maxFractionDigits : 0, min: props.min, max: props.max, step: props.step, showButtons: !!props.step, buttonLayout: 'horizontal', incrementButtonIcon: "pi pi-plus", decrementButtonIcon: "pi pi-minus", disabled: props.disabled != null ? props.disabled : !props.edit, tabIndex: props.tabIndex, value: props.value || (field === null || field === void 0 ? void 0 : field.value), onBlur: (e) => {
                if (props.onBlur) {
                    props.onBlur(e);
                }
            }, onChange: (e) => {
                field === null || field === void 0 ? void 0 : field.onChange(e.value);
                if (props.onChange) {
                    props.onChange(e.value);
                }
            } }));
    };
    const getCalendar = (field, fieldState) => {
        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "p-input-icon-right w-full" }, { children: [(0, jsx_runtime_1.jsx)("i", { className: "pi pi-calendar", style: { fontSize: '1.125rem' } }), (0, jsx_runtime_1.jsx)(calendar_1.Calendar, Object.assign({ ref: ref, id: field === null || field === void 0 ? void 0 : field.name, className: className + ' w-full ' + (0, utils_1.classNames)({ 'p-invalid': fieldState === null || fieldState === void 0 ? void 0 : fieldState.invalid }), showTime: props.showTime != null ? props.showTime : true, dateFormat: "dd.mm.yy", disabled: props.disabled != null ? props.disabled : !props.edit, value: props.value || (field === null || field === void 0 ? void 0 : field.value), minDate: props.minDate, maxDate: props.maxDate, tabIndex: props.tabIndex, onHide: (e) => {
                        if (props.onBlur) {
                            props.onBlur(e);
                        }
                    }, onChange: (e) => {
                        field === null || field === void 0 ? void 0 : field.onChange(e);
                        if (props.onChange) {
                            props.onChange(e);
                        }
                    } }, props.options))] })));
    };
    const getDropdown = (field, fieldState) => {
        return ((0, jsx_runtime_1.jsx)(dropdown_1.Dropdown, Object.assign({ id: field === null || field === void 0 ? void 0 : field.name, ref: ref, focusInputRef: focusRef, className: className + ' w-full ' + (0, utils_1.classNames)({ 'p-invalid': fieldState === null || fieldState === void 0 ? void 0 : fieldState.invalid }), disabled: props.disabled != null ? props.disabled : !props.edit, name: field === null || field === void 0 ? void 0 : field.name, scrollHeight: props.scrollHeight || '200px', filter: true, editable: props.dropdownEditable, filterInputAutoFocus: !(0, Global_1.isTablet)(), showClear: props.showClear, options: props.dropdownOptions, itemTemplate: props.options && props.options.optionLabel ? (item) => {
                if (item) {
                    return item[props.options.optionLabel];
                }
            } : undefined, valueTemplate: props.options && props.options.optionLabel ? (item) => {
                if (item) {
                    return item[props.options.optionLabel];
                }
            } : undefined, placeholder: props.placeholder, value: props.value !== undefined ? props.value : field === null || field === void 0 ? void 0 : field.value, tabIndex: props.tabIndex, onBlur: (e) => {
                if (props.onBlur) {
                    props.onBlur(e);
                }
            }, onChange: (e) => {
                if (typeof e.value === 'undefined')
                    e.value = null; // possible onClear
                field === null || field === void 0 ? void 0 : field.onChange(e.value);
                if (props.onChange) {
                    props.onChange(e);
                }
            }, onHide: () => {
                if (focusRef.current) {
                    focusRef.current.focus();
                }
            } }, props.options)));
    };
    const getMultiselect = (field, fieldState) => {
        return ((0, jsx_runtime_1.jsx)(multiselect_1.MultiSelect, Object.assign({ id: field === null || field === void 0 ? void 0 : field.name, ref: ref, className: className + ' w-full ' + (0, utils_1.classNames)({ 'p-invalid': fieldState === null || fieldState === void 0 ? void 0 : fieldState.invalid }), disabled: props.disabled != null ? props.disabled : !props.edit, name: field === null || field === void 0 ? void 0 : field.name, scrollHeight: props.scrollHeight || '200px', filter: true, showClear: false, optionLabel: 'label', optionDisabled: 'disabled', display: 'chip', options: props.dropdownOptions, value: props.value || (field === null || field === void 0 ? void 0 : field.value), tabIndex: props.tabIndex, 
            // contentEditable={true}
            onBlur: (e) => {
                if (props.onBlur) {
                    props.onBlur(e);
                }
            }, onChange: (e) => {
                field === null || field === void 0 ? void 0 : field.onChange(e.value);
                if (props.onChange) {
                    props.onChange(e);
                }
            }, onShow: () => {
                if (props.onShow) {
                    props.onShow();
                }
            }, onHide: () => {
                if (props.onHide) {
                    props.onHide();
                }
            } }, props.options)));
    };
    const getGroupedDropdown = (field, fieldState) => {
        return ((0, jsx_runtime_1.jsx)(dropdown_1.Dropdown, Object.assign({ id: field === null || field === void 0 ? void 0 : field.name }, field, { ref: ref, className: className + ' w-full ' + (0, utils_1.classNames)({ 'p-invalid': fieldState === null || fieldState === void 0 ? void 0 : fieldState.invalid }), disabled: props.disabled != null ? props.disabled : !props.edit, name: field === null || field === void 0 ? void 0 : field.name, scrollHeight: props.scrollHeight || '200px', filter: true, options: props.dropdownOptions, value: props.value || (field === null || field === void 0 ? void 0 : field.value), itemTemplate: (item) => {
                if (item) {
                    return props.options && props.options.optionLabel ? item[props.options.optionLabel] : item.label;
                }
            }, valueTemplate: (item) => {
                if (item) {
                    return props.options && props.options.optionLabel ? item[props.options.optionLabel] : item.label;
                }
            }, tabIndex: props.tabIndex, optionLabel: "label", optionGroupLabel: "label", optionGroupChildren: "items", optionGroupTemplate: groupedItemTemplate, onBlur: (e) => {
                if (props.onBlur) {
                    props.onBlur(e);
                }
            }, onChange: (e) => {
                field === null || field === void 0 ? void 0 : field.onChange(e.value);
                if (props.onChange) {
                    props.onChange(e);
                }
            } })));
    };
    const getInputSwitch = (field, fieldState) => {
        return ((0, jsx_runtime_1.jsx)(inputswitch_1.InputSwitch, { ref: ref, className: 'mt-3', disabled: props.disabled != null ? props.disabled : !props.edit, name: props.name, checked: props.value, tabIndex: props.tabIndex, onBlur: (e) => {
                if (props.onBlur) {
                    props.onBlur(e);
                }
            }, onChange: (e) => {
                if (props.onChange) {
                    props.onChange(e);
                }
            } }));
    };
    const getTextArea = (field, fieldState) => {
        return ((0, jsx_runtime_1.jsx)(inputtextarea_1.InputTextarea, Object.assign({ id: field === null || field === void 0 ? void 0 : field.name }, field, { ref: ref, className: className + ' w-full ' + (0, utils_1.classNames)({ 'p-invalid': fieldState === null || fieldState === void 0 ? void 0 : fieldState.invalid }), disabled: props.disabled != null ? props.disabled : !props.edit, name: props.name, rows: props.rows, autoResize: true, value: props.value || ((field === null || field === void 0 ? void 0 : field.value) === null ? '' : field === null || field === void 0 ? void 0 : field.value), tabIndex: props.tabIndex, onBlur: (e) => {
                if (props.onBlur) {
                    props.onBlur(e);
                }
            }, onChange: (e) => {
                // Wenn das Inputfeld vom User komplett geleert wird, bleibt ein leerer String zurück.
                // Das würde dann so in die Datenbank geschrieben werden. Damit Null-Werte gespeichert
                // werden, wird der Wert auf null gesetzt.
                let _e = e;
                if (e.target.value === '') {
                    _e = Object.assign(Object.assign({}, e), { target: {
                            value: null
                        } });
                }
                field === null || field === void 0 ? void 0 : field.onChange(_e);
                if (props.onChange) {
                    props.onChange(_e);
                }
            } })));
    };
    const getCheckbox = (field, fieldState) => {
        let timestamp = new Date().getTime();
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(checkbox_1.Checkbox, { ref: ref, inputId: (field === null || field === void 0 ? void 0 : field.name) ? field.name : 'checkbox_' + timestamp, className: (0, utils_1.classNames)(className, 'mt-2', { 'p-invalid': fieldState === null || fieldState === void 0 ? void 0 : fieldState.invalid }, props.inputClassName), disabled: props.disabled != null ? props.disabled : !props.edit, checked: props.value ? (props.value === true || props.value === 'true' ? true : false) : field === null || field === void 0 ? void 0 : field.value, tabIndex: props.tabIndex, onBlur: (e) => {
                        if (props.onBlur) {
                            props.onBlur(e);
                        }
                    }, onChange: (e) => {
                        field === null || field === void 0 ? void 0 : field.onChange(e.checked);
                        if (props.onChange) {
                            props.onChange(e);
                        }
                    } }), props.label &&
                    (0, jsx_runtime_1.jsx)("label", Object.assign({ htmlFor: (field === null || field === void 0 ? void 0 : field.name) ? field.name : 'checkbox_' + timestamp, className: 'm-auto pl-2 cursor-pointer', style: { 'fontWeight': 'bold' } }, { children: props.label + (props.validationControl && props.validationRules.required ? '*' : '') })), props.tooltip && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(tooltip_1.Tooltip, { target: '.' + tooltipName, content: props.tooltip }), (0, jsx_runtime_1.jsx)("i", { className: 'pi pi-info-circle pl-2 my-auto ' + tooltipName })] })] }));
    };
    const getSelectButton = (field, fieldState) => {
        return ((0, jsx_runtime_1.jsx)(selectbutton_1.SelectButton, { className: className + ' w-full ' + (0, utils_1.classNames)({ 'p-invalid': fieldState === null || fieldState === void 0 ? void 0 : fieldState.invalid }), disabled: props.disabled != null ? props.disabled : !props.edit, value: props.value || (field === null || field === void 0 ? void 0 : field.value), tabIndex: props.tabIndex, options: props.selectButtonOptions, optionLabel: "name", onBlur: (e) => {
                if (props.onBlur) {
                    props.onBlur(e);
                }
            }, onChange: (e) => {
                field === null || field === void 0 ? void 0 : field.onChange(e.checked);
                if (props.onChange) {
                    props.onChange(e);
                }
            } }));
    };
    const getButton = (field, fieldState) => {
        return ((0, react_1.createElement)(button_1.Button, Object.assign({}, props.options, { key: 'butt_' + 1, id: field === null || field === void 0 ? void 0 : field.name, style: { backgroundColor: 'rgba(68, 72, 109, 0.07)' }, className: className + ' w-full p-button-outlined' + (0, utils_1.classNames)({ 'p-invalid': fieldState === null || fieldState === void 0 ? void 0 : fieldState.invalid }), disabled: props.disabled != null ? props.disabled : !props.edit, name: field === null || field === void 0 ? void 0 : field.name, label: props.value, tabIndex: props.tabIndex, onClick: (event) => {
                event.preventDefault();
                if (props.onClick)
                    props.onClick(event);
            } })));
    };
    const getTreeSelect = (field, fieldState) => {
        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'relative' }, { children: [(0, jsx_runtime_1.jsx)(treeselect_1.TreeSelect, { className: className + ' w-full ' + (0, utils_1.classNames)({ 'p-invalid': fieldState === null || fieldState === void 0 ? void 0 : fieldState.invalid }), disabled: props.disabled != null ? props.disabled : !props.edit, value: props.value || (field === null || field === void 0 ? void 0 : field.value), tabIndex: props.tabIndex, options: props.dropdownOptions, selectionMode: props.selectionMode, display: displayStr, onBlur: (e) => {
                        if (props.onBlur) {
                            props.onBlur(e);
                        }
                    }, onChange: (e) => {
                        field === null || field === void 0 ? void 0 : field.onChange(e);
                        if (props.onChange) {
                            props.onChange(e);
                        }
                    }, scrollHeight: props.scrollHeight || '200px', filter: true }), props.showClear && (field === null || field === void 0 ? void 0 : field.value) &&
                    (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'tree-select-close' }, { children: (0, jsx_runtime_1.jsx)(button_1.Button, { icon: 'pi pi-times', className: 'p-button-text absolute', "aria-label": 'Cancel', onClick: (event) => {
                                event.preventDefault();
                                const e = { value: null };
                                field === null || field === void 0 ? void 0 : field.onChange(e.value);
                                if (props.onChange)
                                    props.onChange(e);
                            } }) }))] })));
    };
    const getSlider = (field, fieldState) => {
        var _a;
        const value = props.value !== null && props.value !== undefined ? props.value : ((field === null || field === void 0 ? void 0 : field.value) == null ? 0 : field === null || field === void 0 ? void 0 : field.value);
        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ id: `${props.name}-slider` }, { children: [(0, jsx_runtime_1.jsx)(tooltip_1.Tooltip, { target: `#${props.name}-slider .p-slider-handle`, content: (_a = props.tooltip) !== null && _a !== void 0 ? _a : String(value), position: "top" }), (0, jsx_runtime_1.jsx)(slider_1.Slider, Object.assign({ id: field === null || field === void 0 ? void 0 : field.name }, field, spread, props.options, { ref: ref, className: className + ' w-full ' + (0, utils_1.classNames)({ 'p-invalid': fieldState === null || fieldState === void 0 ? void 0 : fieldState.invalid }), disabled: props.disabled != null ? props.disabled : !props.edit, value: value, tabIndex: props.tabIndex, onBlur: (e) => {
                        if (props.onBlur) {
                            props.onBlur(e);
                        }
                    }, onChange: (e) => {
                        field === null || field === void 0 ? void 0 : field.onChange(e);
                        if (props.onChange) {
                            props.onChange(e);
                        }
                    } })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'w-full flex justify-content-between mt-2' }, { children: [(0, jsx_runtime_1.jsx)("div", { children: props.min || 0 }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'cursor-pointer', onClick: () => {
                                field === null || field === void 0 ? void 0 : field.onChange({ value: props.max || 100 });
                                if (props.onChange) {
                                    props.onChange({ value: props.max || 100 });
                                }
                            } }, { children: props.max || 100 }))] }))] })));
    };
    const getInputText = (field, fieldState) => {
        return ((0, jsx_runtime_1.jsx)(inputtext_1.InputText, Object.assign({ id: field === null || field === void 0 ? void 0 : field.name }, field, spread, { ref: ref, className: className + ' w-full ' + (0, utils_1.classNames)({ 'p-invalid': fieldState === null || fieldState === void 0 ? void 0 : fieldState.invalid }), disabled: props.disabled != null ? props.disabled : !props.edit, value: props.value || ((field === null || field === void 0 ? void 0 : field.value) == null ? '' : field === null || field === void 0 ? void 0 : field.value), tabIndex: props.tabIndex, onBlur: (e) => {
                if (props.onBlur) {
                    props.onBlur(e);
                }
            }, onChange: (e) => {
                // Wenn das Inputfeld vom User komplett geleert wird, bleibt ein leerer String zurück.
                // Das würde dann so in die Datenbank geschrieben werden. Damit Null-Werte gespeichert
                // werden, wird der Wert auf null gesetzt.
                let _e = e;
                if (e.target.value === '') {
                    _e = Object.assign(Object.assign({}, e), { target: {
                            value: null
                        } });
                }
                field === null || field === void 0 ? void 0 : field.onChange(_e);
                if (props.onChange) {
                    props.onChange(_e);
                }
            } })));
    };
    const onClickClipboard = (field) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            if ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText) {
                yield navigator.clipboard.writeText(props.value ? props.value : field === null || field === void 0 ? void 0 : field.value);
                (0, CustomToast_1.showMessageOnSuccess)(t('success'), t('clipboard_success'));
            }
        }
        catch (err) {
            (0, CustomToast_1.showMessageOnError)(t('error'), err);
        }
        return false;
    });
    // exclude edit from spreadoperator
    const { edit } = props, spread = __rest(props, ["edit"]);
    spread.dropdownOptions = null;
    delete spread.dropdownOptions;
    spread.selectionMode = null;
    delete spread.selectionMode;
    spread.dropdownOptions = null;
    delete spread.dropdownOptions;
    spread.showClear = undefined;
    delete spread.showClear;
    // if (props.edit) {
    switch (props.type) {
        case 'number':
            component = props.validationControl ?
                ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "field" }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [inputLabel, (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: props.name, control: props.validationControl, rules: props.validationRules || { required: t('input_required') }, render: ({ field, fieldState }) => {
                                    if (props.showClipboard) {
                                        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "p-inputgroup" }, { children: [getInputNumber(field, fieldState), (0, jsx_runtime_1.jsx)(button_1.Button, { icon: "pi pi-copy", className: "p-button-secondary", onClick: (e) => {
                                                        e.preventDefault();
                                                        onClickClipboard(field);
                                                    } })] })));
                                    }
                                    else {
                                        return getInputNumber(field, fieldState);
                                    }
                                } }), props.validationErrorMessage ? props.validationErrorMessage(props.name) : null] }) })))
                : ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "field" }, { children: [inputLabel, props.showClipboard && (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "p-inputgroup" }, { children: [getInputNumber(null, null), (0, jsx_runtime_1.jsx)(button_1.Button, { icon: "pi pi-copy", className: "p-button-secondary", onClick: (e) => {
                                        e.preventDefault();
                                        onClickClipboard(null);
                                    } })] })), !props.showClipboard && getInputNumber(null, null)] })));
            break;
        case 'date':
            component = props.validationControl ?
                ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "field" }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [inputLabel, (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: props.name, control: props.validationControl, rules: props.validationRules || { required: t('input_required') }, render: ({ field, fieldState }) => getCalendar(field, fieldState) }), props.validationErrorMessage ? props.validationErrorMessage(props.name) : null] }) })))
                : ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "field" }, { children: [inputLabel, getCalendar(null, null)] })));
            break;
        case 'dropdown':
            component = props.validationControl
                ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "field" }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [inputLabel, (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: props.name, control: props.validationControl, rules: props.validationRules || { required: t('input_required') }, render: ({ field, fieldState }) => {
                                    if (props.showClipboard) {
                                        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "p-inputgroup" }, { children: [getDropdown(field, fieldState), (0, jsx_runtime_1.jsx)(button_1.Button, { icon: "pi pi-copy", className: "p-button-secondary", onClick: (e) => {
                                                        e.preventDefault();
                                                        onClickClipboard(field);
                                                    } })] })));
                                    }
                                    else {
                                        return getDropdown(field, fieldState);
                                    }
                                } }), props.validationErrorMessage ? props.validationErrorMessage(props.name) : null] }) })))
                : ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "field" }, { children: [inputLabel, props.showClipboard && (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "p-inputgroup" }, { children: [getDropdown(null, null), (0, jsx_runtime_1.jsx)(button_1.Button, { icon: "pi pi-copy", className: "p-button-secondary", onClick: (e) => {
                                        e.preventDefault();
                                        onClickClipboard(null);
                                    } })] })), !props.showClipboard && getDropdown(null, null)] })));
            break;
        case 'multiselect':
            component = props.validationControl
                ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "field" }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [inputLabel, (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: props.name, control: props.validationControl, rules: props.validationRules || { required: t('input_required') }, render: ({ field, fieldState }) => getMultiselect(field, fieldState) }), props.validationErrorMessage ? props.validationErrorMessage(props.name) : null] }) })))
                : ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "field" }, { children: [inputLabel, getMultiselect(null, null)] })));
            break;
        case 'groupeddropdown':
            component = props.validationControl ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "field" }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [inputLabel, (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: props.name, control: props.validationControl, rules: props.validationRules || { required: t('input_required') }, render: ({ field, fieldState }) => getGroupedDropdown(field, fieldState) }), props.validationErrorMessage ? props.validationErrorMessage(props.name) : null] }) }))) :
                ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "field" }, { children: [getGroupedDropdown(null, null), props.label && (0, jsx_runtime_1.jsx)("h5", Object.assign({ className: "input-label" }, { children: props.label }))] })));
            break;
        case 'inputswitch':
            component = props.validationControl
                ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "field" }, { children: (0, jsx_runtime_1.jsx)("h5", { children: "ValidationControl not working" }) })))
                : ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "field" }, { children: [props.label
                            ? (0, jsx_runtime_1.jsx)("h5", Object.assign({ className: 'mt-3' }, { children: props.label }))
                            : null, getInputSwitch(null, null)] })));
            break;
        case 'textarea':
            component = props.validationControl ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "field" }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [inputLabel, (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: props.name, control: props.validationControl, rules: props.validationRules || { required: t('input_required') }, render: ({ field, fieldState }) => getTextArea(field, fieldState) }), props.validationErrorMessage ? props.validationErrorMessage(props.name) : null] }) }))) :
                ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "field" }, { children: [inputLabel, getTextArea(null, null)] })));
            break;
        case 'checkbox':
            component = props.validationControl ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, utils_1.classNames)('field', props.noMargin === true ? '' : 'mt-4', props.className) }, { children: (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: props.name, control: props.validationControl, rules: props.validationRules || { required: t('input_required') }, render: ({ field, fieldState }) => getCheckbox(field, fieldState) }) }))) :
                ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, utils_1.classNames)('field col-12', props.noMargin === true ? '' : 'mt-4', props.className) }, { children: getCheckbox(null, null) })));
            break;
        case 'selectButton':
            component = props.validationControl
                ? ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'field mt-2' }, { children: [props.label &&
                            (0, jsx_runtime_1.jsx)("h5", { children: props.label + (props.validationControl && props.validationRules.required ? '*' : '') }), (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: props.name, control: props.validationControl, rules: props.validationRules || { required: t('input_required') }, render: ({ field, fieldState }) => getSelectButton(field, fieldState) })] })))
                : ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'field mt-2' }, { children: [props.label && (0, jsx_runtime_1.jsx)("h5", { children: props.label }), getSelectButton(null, null)] })));
            break;
        case 'treeSelect':
            component = props.validationControl
                ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "field" }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [inputLabel, (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: props.name, control: props.validationControl, rules: props.validationRules || { required: t('input_required') }, render: ({ field, fieldState }) => getTreeSelect(field, fieldState) }), props.validationErrorMessage ? props.validationErrorMessage(props.name) : null] }) })))
                : ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'field' }, { children: [inputLabel, getTreeSelect(null, null)] })));
            break;
        case 'button':
            component = props.validationControl
                ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "field" }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [inputLabel, (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: props.name, control: props.validationControl, rules: props.validationRules || { required: t('input_required') }, render: ({ field, fieldState }) => getButton(field, fieldState) }), props.validationErrorMessage ? props.validationErrorMessage(props.name) : null] }) })))
                : ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "field" }, { children: [inputLabel, getButton(null, null)] })));
            break;
        case 'slider':
            component = props.validationControl ?
                ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "field" }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [inputLabel, (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: props.name, control: props.validationControl, rules: props.validationRules || { required: t('input_required') }, render: ({ field, fieldState }) => {
                                    return getSlider(field, fieldState);
                                } }), props.validationErrorMessage ? props.validationErrorMessage(props.name) : null] }) }))) : ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "field" }, { children: [inputLabel, getSlider(null, null)] })));
            break;
            break;
        default:
            component = props.validationControl ?
                ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "field" }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [inputLabel, (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: props.name, control: props.validationControl, rules: props.validationRules || { required: t('input_required') }, render: ({ field, fieldState }) => {
                                    if (props.showClipboard) {
                                        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "p-inputgroup" }, { children: [getInputText(field, fieldState), (0, jsx_runtime_1.jsx)(button_1.Button, { icon: "pi pi-copy", className: "p-button-secondary", onClick: (e) => {
                                                        e.preventDefault();
                                                        onClickClipboard(field);
                                                    } })] })));
                                    }
                                    else {
                                        return getInputText(field, fieldState);
                                    }
                                } }), props.validationErrorMessage ? props.validationErrorMessage(props.name) : null] }) }))) : ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "field" }, { children: [inputLabel, props.showClipboard && (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "p-inputgroup" }, { children: [getInputText(null, null), (0, jsx_runtime_1.jsx)(button_1.Button, { icon: "pi pi-copy", className: "p-button-secondary", onClick: (e) => {
                                    e.preventDefault();
                                    onClickClipboard(null);
                                } })] })), !props.showClipboard && getInputText(null, null)] })));
            break;
    }
    // } else {
    //     component = props.validationControl
    //         ? (<div className="field">
    //             <Controller
    //                 name={props.name}
    //                 control={props.validationControl}
    //                 rules={props.validationRules || {required: t('input_required')}}
    //                 render={({field, fieldState}) =>
    //                     (<>
    //                         <h5 className="p-0 m-0 mt-3 mb-1">{props.label}</h5>
    //                         <div className="ml-2">{props.value || field.value || '-'}</div>
    //                     </>)}
    //             />
    //             {props.validationErrorMessage ? props.validationErrorMessage(props.name) : null}
    //         </div>)
    //         : (<div className="field">
    //             <>
    //                 <div className="flex"><h5 className="p-0 m-0 mt-3 mb-1">{props.label}</h5>
    //                     {props.tooltip &&
    //                     <>
    //                         <Tooltip target=".pi" content={props.tooltip}/>
    //                         <i className="pi pi-info-circle pl-2 my-auto"/>
    //                     </>}
    //                 </div>
    //                 <div className="ml-2">{props.value || '-'}</div>
    //             </>
    //         </div>);
    // }
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, utils_1.classNames)('custom-input w-full relative', (props.className ? props.className : '')) }, { children: component })));
};
exports.Input = Input;
